import { component } from 'picoapp'

class Footer {

  constructor(node, ctx) {
    // bindings
    this.onPJAXSuccess = this.onPJAXSuccess.bind(this)

    // Footer selectors
    this._node = node;
    this._nav_links = document.getElementsByClassName('nav-link')

    // CTX
    this._ctx = ctx

    // Event listeners
    document.addEventListener('pjax:success', this.onPJAXSuccess)

    // Init
    if (this._ctx.getState().pjax === false) {
      this.init()
    }

    return this.unmount.bind(this)
  }

  //
  // Init.
  //
  init() {
    // this.setActiveStuff()
  }

  //
  // Handle PJAX success.
  //
  onPJAXSuccess() {
    // this.setActiveStuff()
  }

  //
  // Set active stuff.
  //
  setActiveStuff() {
    let path = window.location.pathname

    if (path.split('/')[1] === 'account') {
      path = '/account'
    }

    Array.from(this._nav_links).forEach((link) => {
      let href = link.getAttribute('href')
      link.classList.remove('active')

      if (path === href) {
        link.classList.add('active')
      }
    })
  }

  //
  // Unmount.
  //
  unmount() {
    document.removeEventListener('pjax:success', this.onPJAXSuccess)
  }
}

export default component((node, ctx) => new Footer(node, ctx))
